export const conversionsObjectiveGoalOptions = [
  { key: 0, value: 'OFFSITE_CONVERSIONS', text: 'View Content' },
  {
    key: 1,
    value:
      '{"and":[{"event":{"eq":"PageView"}‌},{"or":[{"URL":{"i_contains":"DISPLAY LINK"}‌}]}]}',
    text: 'Site Traffic'
  }
];

export const optimizationGoalsValues = {
  CONVERSIONS: conversionsObjectiveGoalOptions,
  VIDEO_VIEWS: [{ key: 0, value: 'THRUPLAY', text: 'Thruplay' }],
  LINK_CLICKS: [
    { key: 0, value: 'LANDING_PAGE_VIEWS', text: 'Landing Page Views' }
    // { key: 1, value: 'LINK_CLICKS', text: 'Link Clicks' } // launching adsets with optimization_goal === "LINK_CLICKS" doesn't launch currently
  ],
  PRODUCT_CATALOG_SALES: [
    { key: 0, value: 'OFFSITE_CONVERSIONS', text: 'Conversions' },
    { key: 1, value: 'LINK_CLICKS', text: 'Link Clicks' }
  ]
};



// WEBPACK FOOTER //
// ./src/components/common/OptimizationGoals.js